module.exports = __webpack_public_path__ + "build/img/05.0d637b7b.jpg";